export default __webpack_public_path__ + "static/media/mywishes-logo-black.d904cb40.png";